import React from 'react';
import useBIF from 'data/hooks/useBIF';
import useMe from 'data/hooks/useMe';
import type { InferType } from 'yup';
import { useSnackbar } from 'notistack';
import { AddressType, submitBIF } from 'data/requests/submitBIF';
import { validationSchema } from './constants';

type SubmitBIFPayload = {
  payload: InferType<typeof validationSchema>;
  legalAddress: AddressType;
};

const useConnect = () => {
  const { me } = useMe();
  const { isLoading, BIF, refetch } = useBIF(me?.organizationId || '');
  const { enqueueSnackbar } = useSnackbar();

  const SUCCESS_MESSAGE =
    'We’ve received your updated banking information and will reach out if there are any issues.';

  const handleSubmit = async ({ payload, legalAddress }: SubmitBIFPayload) => {
    const { code, body } = await submitBIF(
      {
        ...payload,
        legal_address: legalAddress as AddressType,
        device_info: {
          user: me?.userId,
        },
      },
      me!.organizationId,
    );
    if (code === 201) {
      enqueueSnackbar(SUCCESS_MESSAGE, { variant: 'success' });
    } else {
      const error =
        body?.detail ||
        'Something went wrong, please contact support for help.';
      enqueueSnackbar(error, { variant: 'error' });
    }
  };

  React.useEffect(() => {
    if (me) {
      refetch();
    }
  }, [me, refetch]);

  return {
    isLoading,
    BIF,
    handleSubmit,
  };
};

export default useConnect;
